module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout Common */

(function(fox) {
	fox.registerWidget('Layout_Common', {

		configure: function () {

			this.registerOptions('', {
				pageContainer: '.common-content',
				'templateOptions.domain': '',

				'widgets.header': {
					widget: 'Promo_Header'
				},
						
				'widgets.footer': {
					widget: 'Promo_Footer'
				},

				'handleWom.renderHeader': {
					widget: '.Site_Page .Widget',
					event: 'activate',
					callback: 'renderHeader'
				},

				'handleWom.markLink': {
					widget: '#header',
					event: 'addedToDom',
					callback: 'markLink'
				}
			});

			this.callParent('configure', arguments);
		},

		renderHeader: function () {
			this.rwom1('#header').setTemplateOptions({member: fox.site.member, domain: this.getOption('templateOptions.domain')}).render();
			this.rwom1('#footer').setTemplateOptions({member: fox.site.member, domain: this.getOption('templateOptions.domain')}).render();
		},

		markLink: function (obj, w, e) {
			var page = fox.Navigator.get(0);
			var links = w.dom('.lnk');
			var attr = 'goto';

			if (page == 'home') {
				page = fox.Navigator.get(1);
				attr = 'alias';
			};

			fox.each(links, function (link) {
				var link = fox.dom.wrap(link);

				link.removeClass('active')
				if (link.attr(attr) == page) {
					link.addClass('active')
				}
			})
		}

	}, 'Site_Layout');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/layout/common.js
// module id = 322
// module chunks = 2